// src/contexts/MockBusinessContext.js
import React from "react";

export const MockBusinessContext = React.createContext();

export const MockBusinessProvider = ({ children }) => {
  const mockBusiness = {
    selectedBusiness: { name: "Demo Business", rating: 4.5, turnover: 50000 },
    currencySymbol: "$",
  };

  return (
    <MockBusinessContext.Provider value={mockBusiness}>
      {children}
    </MockBusinessContext.Provider>
  );
};
